/* cordy-3d-tile.js
   --------------------------------------------------------------------------
   Kleine 3D-Buehne als Kachel in der Foto-Wand (cordy-problem-solution,
   layout=gallery). Dieselbe Buehne wie im Konfigurator, nur ohne Bedienung:
   sie dreht sich etwas schneller und wechselt die Farbe von allein.

   Die Farbrechnung kommt aus assets/cordy-3d-color.js (window.CordyColor).

   Sparsam von Haus aus: model-viewer und das GLB werden erst geholt, wenn die
   Kachel in die Naehe des Sichtfensters kommt. Der Farbwechsel laeuft nur,
   solange die Kachel sichtbar und der Tab im Vordergrund ist. Bei
   prefers-reduced-motion steht das Modell still und behaelt die erste Farbe.

   Die Adresse des model-viewer-Skripts steht als ATTRIBUT am Element, nicht
   als JS-String: `shopify theme dev` schreibt nur Attribute auf den lokalen
   Host um. Als String bliebe //cordy-6931.myshopify.com stehen, ein fremder
   Host ueber HTTP - Chrome holt den nicht, model-viewer wird nie definiert,
   und die Kachel bleibt stumm leer. */
(function () {
  if (customElements.get('cordy-3d-tile')) return;

  var FADE_MS = 420;

  customElements.define('cordy-3d-tile', class extends HTMLElement {
    connectedCallback() {
      this.viewer = this.querySelector('model-viewer');

      /* Der Farbname steht in der <figcaption> der Kachel - die ist
         Geschwister dieses Elements, nicht Kind: figcaption muss laut HTML
         direktes Kind der <figure> sein. Deshalb ab der Figure suchen. */
      var scope = this.closest('figure') || this.parentElement || this;
      this.nameEl = scope.querySelector('[data-cordy-tile-name]');

      try {
        this.colors = JSON.parse(this.getAttribute('data-colors') || '[]');
      } catch (e) {
        this.colors = [];
      }
      if (!this.colors.length) return;

      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 2000;
      this.boost = (parseFloat(this.getAttribute('data-boost')) || 118) / 100;
      this.matNames = (this.getAttribute('data-materials') || '')
        .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      this.index = 0;

      this.reduceMotion = !!(window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (this.reduceMotion && this.viewer) this.viewer.removeAttribute('auto-rotate');

      // Fehlt die Poster-Datei, soll kein kaputtes Bild auf der Kachel liegen.
      var poster = this.querySelector('[data-cordy-tile-poster]');
      if (poster) poster.addEventListener('error', function () { poster.remove(); });

      this.showName(this.colors[0]);
      this.watch();

      if (!this.viewer) return;
      this.viewer.addEventListener('load', () => {
        this.ready = true;
        this.lightUp();
        this.recolor(this.colors[0], false);
        this.resume();
      });
    }

    disconnectedCallback() {
      this.pause();
      if (this.io) this.io.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* Erst laden, wenn die Kachel naeht: model-viewer (914 KB) und das GLB
       haengen sonst an jedem Seitenaufbau. Der Merker sitzt am Element, nicht
       am window - im Theme-Editor wird die Sektion neu gerendert und das neue
       Element braucht einen eigenen Beobachter. */
    watch() {
      var src = this.getAttribute('data-mv-src');
      var load = function () {
        if (!src || customElements.get('model-viewer') || window.__cordyMvScript) return;
        window.__cordyMvScript = true;
        var s = document.createElement('script');
        s.type = 'module';
        s.src = src;
        document.head.appendChild(s);
      };

      if (!('IntersectionObserver' in window)) { load(); this.visible = true; return; }

      this.io = new IntersectionObserver((entries) => {
        for (var i = 0; i < entries.length; i++) {
          this.visible = entries[i].isIntersecting;
          if (this.visible) { load(); this.resume(); } else { this.pause(); }
        }
      }, { rootMargin: '400px 0px' });
      this.io.observe(this);

      this.onVisibility = () => {
        if (document.hidden) this.pause(); else this.resume();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    resume() {
      if (this.timer || !this.ready || !this.visible || document.hidden) return;
      if (this.reduceMotion || this.colors.length < 2) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    pause() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
    }

    next() {
      this.index = (this.index + 1) % this.colors.length;
      var c = this.colors[this.index];
      this.showName(c);
      this.recolor(c, true);
    }

    showName(c) {
      if (this.nameEl && c && c[0]) this.nameEl.textContent = c[0];
    }

    /* Studio-Umgebung nachziehen, erst wenn das Modell schon steht.
       Reihenfolge ist Absicht: erst sichtbar, dann schoen. Als Attribut haelt
       eine Umgebung die ganze Buehne auf - kommt die Datei nicht durch, laedt
       model-viewer auch das Modell nicht und meldet nichts. */
    lightUp() {
      var env = this.getAttribute('data-env');
      if (!env || this.litUp) return;
      this.litUp = true;
      this.viewer.setAttribute('environment-image', env);
      setTimeout(() => {
        if (this.ready) this.recolor(this.colors[this.index], false);
      }, 400);
    }

    // c = [Name, Hex Ring, Hex Kordel]
    recolor(c, animate) {
      var CC = window.CordyColor;
      if (!CC || !this.viewer || !this.viewer.model || !c) return;

      var exposure = CC.exposureOf(this.viewer);
      var to = {
        abs: CC.hexToFactor(c[1], CC.MAT_ABS, this.boost, exposure),
        cord: CC.hexToFactor(c[2] || c[1], CC.MAT_CORD, this.boost, exposure)
      };
      if (!to.abs) return;
      if (!to.cord) to.cord = to.abs;

      var from = this.shown;
      this.shown = to;
      if (!animate || !from || this.reduceMotion) {
        CC.paint(this.viewer, to, this.matNames);
        return;
      }

      /* Weicher Uebergang statt hartem Umschalten - der Wechsel wirkt wie am
         Produkt, nicht wie ein Bildtausch. Etwas laenger als im Konfigurator
         (dort 220 ms): dort folgt er einem Klick, hier laeuft er von allein
         und darf nicht zucken. */
      var start = performance.now();
      var self = this;
      if (this.raf) cancelAnimationFrame(this.raf);
      var step = function (now) {
        var k = Math.min(1, (now - start) / FADE_MS);
        var e = k * k * (3 - 2 * k);
        CC.paint(self.viewer, {
          abs: CC.mixFactor(from.abs, to.abs, e),
          cord: CC.mixFactor(from.cord, to.cord, e)
        }, self.matNames);
        if (k < 1) self.raf = requestAnimationFrame(step);
        else self.raf = null;
      };
      this.raf = requestAnimationFrame(step);
    }
  });
})();
